// 仅允许以下tag列表允许部分的属性展示
export default {
    a: ['href', 'title', 'target', 'style'],
    br: [],
    div: ['style', 'data-w-e-type'],
    u: ['style'],
    em: ['style'],
    h1: ['style'],
    h2: ['style'],
    h3: ['style'],
    h4: ['style'],
    h5: ['style'],
    hr: ['style'],
    s: ['style'],
    sub: ['style'],
    sup: ['style'],
    span: ['style'],
    strong: ['style'],
    img: ['src', 'alt', 'title', 'width', 'height', 'style'],
    input: ['type', 'style', 'disabled', 'checked', 'value'],
    p: ['line-height', 'style'],
    table: ['style'],
    tr: ['style'],
    td: ['style'],
    th: ['style'],
    ul: ['style'],
    ol: ['style'],
    li: ['style'],
    video: ['src', 'controls', 'style', 'width', 'height'],
    source: ['src', 'type'],
    tbody: ['style'],
    thead: ['style'],
    tfoot: ['style'],
};
